const Getters = {
  getStockMoveListFromState: (state) => {
    return state.stockMoveList
  },
  // 在庫移動理由
  getStockMoveReasonListFromState: (state) => {
    return state.stockMoveReasonList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
